import { Button } from "@chakra-ui/react";
import { TableProps } from "@/ui/tables/Table";
import { ProductAdjustment } from "@/shared/core-product-adjustments";
import { formatDate } from "@/utils/formatDate";
import { CreatorCell } from "../vouchers/Columns";

export const ProductAdjustmentTableColumns = (
  handleToggleEnabled: (item: ProductAdjustment) => void,
  handleOnClickProducts: (item: ProductAdjustment) => void,
): TableProps<ProductAdjustment>["headers"] => {
  return [
    {
      label: "Tipo de ajuste",
      itemLabel: (item) => item.productAdjustmentType.name,
      sortable: true,
    },
    {
      label: "Descripción",
      itemLabel: "description",
      sortable: true,
      sortKey: "description",
    },
    {
      label: "Fecha",
      itemLabel: (item) => formatDate(item.createdAt),
      sortable: true,
      sortKey: "createdAt",
    },
    {
      label: "Creado por",
      itemLabel: (item) => <CreatorCell name={item.creator?.name} />,
    },
    {
      label: "Productos ajustados",
      itemLabel: (item) => (
        <Button
          size="sm"
          variant="outline"
          onClick={() => handleOnClickProducts(item)}
        >
          {item.products.length} Productos
        </Button>
      ),
    },
    {
      label: "Estado",
      itemLabel: (item) => (
        <Button
          variant="ghost"
          size="sm"
          colorPalette={item.enabled ? "gray" : "green"}
          color={item.enabled ? "fg.muted" : undefined}
          onClick={() => handleToggleEnabled(item)}
        >
          {item.enabled ? "Deshabilitar" : "Habilitar"}
        </Button>
      ),
    },
  ];
};
